import { ThemeProvider } from "@emotion/react";
import CloseIcon from "@mui/icons-material/Close";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import {
  Box,
  Button,
  createTheme,
  IconButton,
  Modal,
  useMediaQuery,
} from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Layout from "./layout";
import BaseAuth from "./pages/auth";
import FrogetPassword from "./pages/auth/forgetPassWord";
import Login from "./pages/auth/login";
import Otp from "./pages/auth/otp";
import QrCode from "./pages/auth/qrCode";
import Register from "./pages/auth/register";
import RegisterModi from "./pages/auth/registerModi";
import SignUp from "./pages/auth/singup";
import Buy from "./pages/buy";
import CustomerBuy from "./pages/buy/customer";
import CreateCustomerBuy from "./pages/buy/customer/create";
import EditCustomerBuy from "./pages/buy/customer/edit";
import InvoiceBuy from "./pages/buy/invoice";
import CreateInvoiceBuy from "./pages/buy/invoice/create";
import EditInvoiceBuy from "./pages/buy/invoice/edit";
import PriviewInvoiceBuy from "./pages/buy/invoice/preview";
import ProductsBuy from "./pages/buy/products";
import CreateProductBuy from "./pages/buy/products/create";
import EditProductBuy from "./pages/buy/products/edit";
import Home from "./pages/home";
import Price from "./pages/price";
import Sell from "./pages/sell";
import Customer from "./pages/sell/customer";
import CreateCustomer from "./pages/sell/customer/create";
import EditCustomer from "./pages/sell/customer/edit";
import Invoice from "./pages/sell/invoice";
import CreateInvoice from "./pages/sell/invoice/create";
import EditInvoice from "./pages/sell/invoice/edit";
import PriviewInvoice from "./pages/sell/invoice/preview";
import Products from "./pages/sell/products";
import CreateProduct from "./pages/sell/products/create";
import EditProduct from "./pages/sell/products/edit";
import Settings from "./pages/setting";
import {
  handleAppVersion,
  handlePopUpPwaAction,
  handleUserDetails,
} from "./redux/actoin";
import { API } from "./scripts/api";
import axiosInstance from "./scripts/axiosInspector";
import useOnlineStatus from "./scripts/hooks/useOnline";

function App() {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const [os, setOs] = useState("");

  const online = useOnlineStatus();
  const dispatch = useDispatch();
  const AppVersion = useSelector((state) => state.AppVersion);
  const { version } = AppVersion;
  const [newVersion, setNewVersion] = useState(false);
  const [openModal, setopenModal] = useState(false);
  const isLg = useMediaQuery("(min-width:1050px)");

  useEffect(() => {
    if (userInfo) {
      axiosInstance
        .get(API.user.profile, {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
        })
        .then((res) => {
          dispatch(handleUserDetails(res.data.data));
        })
        .catch((error) => {});
      axiosInstance
        .get(API.public.version, {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
        })
        .then((res) => {
          if (version) {
            if (version !== res.data.data) {
              /*     window.location.reload(true); */
              setNewVersion(true);
            }
            dispatch(handleAppVersion(res.data.data));
          } else {
            localStorage.setItem("version", res.data.data);
            dispatch(handleAppVersion(res.data.data));
          }
        })
        .catch((err) => {
          /*   if (err.response.status === 401 || err.response.status === 403) {
            dispatch(handleLogOut());
          } */
        });
    }
  }, [userInfo]);
  const { themeDisplay } = useSelector((state) => state.ThemeToggler);
  const { popUp } = useSelector((state) => state.PopUpPwa);

  var dark = themeDisplay === "dark";
  const Theme = createTheme({
    palette: {
      mode: dark ? "dark" : "light",
      background: {
        default: !dark ? "#e1e1ff59" : "#0e102d",
        paper: !dark ? "#fff" : "#2a3042",
      },
      success: {
        main: dark ? "#62d56b" : "#439c4a",
        /* green  */
      },
      warning: {
        main: dark ? "#ff5400" : "#ff5400",
        /* orange  */
      },
      error: {
        main: dark ? "#ff1e00" : "#ff1e00",
        /* red  */
      },
      primary: {
        main: dark
          ? "#5790c8"
          : themeDisplay === "blue"
          ? "#3b5396"
          : themeDisplay === "green"
          ? "#03765b"
          : themeDisplay === "orange"
          ? "#f99f04"
          : "#725EDA",
        /* blue  */
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1570,
        xxl: 1637,
      },
    },
  });
  const handleUpdate = () => {
    caches.keys().then((cacheNames) => {
      cacheNames.forEach((cacheName) => {
        caches.delete(cacheName);
      });
    });

    window.location.reload(true);
    window.location.reload(true);
    localStorage.setItem("version", version);
  };
  useEffect(() => {
    document.body.removeAttribute("class");
    document.body.classList.add(
      `theme-${themeDisplay ? themeDisplay : "purple"}`
    );
  }, [themeDisplay]);
  useEffect(() => {
    if (window.matchMedia("(display-mode: standalone)").matches) {
      dispatch(handlePopUpPwaAction(false));
    } else {
      const storedDateString = localStorage.getItem("la");

      if (storedDateString) {
        const storedDate = new Date(storedDateString);
        const currentDate = new Date();
        const timeDifference = currentDate - storedDate;
        const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
        if (timeDifference < oneDayInMilliseconds) {
        } else {
          dispatch(handlePopUpPwaAction(true));
        }
      } else {
        dispatch(handlePopUpPwaAction(true));
      }
    }
    setOs(getOperatingSystem(window));
  }, []);
  function getOperatingSystem(window) {
    let operatingSystem = "Not known";
    if (window.navigator.appVersion.indexOf("Win") !== -1) {
      operatingSystem = "Windows OS";
    }
    if (window.navigator.appVersion.indexOf("Mac") !== -1) {
      operatingSystem = "MacOS";
    }
    if (window.navigator.appVersion.indexOf("X11") !== -1) {
      operatingSystem = "UNIX OS";
    }
    if (window.navigator.appVersion.indexOf("Linux") !== -1) {
      operatingSystem = "Linux OS";
    }

    return operatingSystem;
  }

  return (
    <div className={`theme-${themeDisplay ? themeDisplay : "purple"}`}>
      <ThemeProvider theme={Theme}>
        <HashRouter>
          {!userInfo ? (
            <>
              <Routes>
                <Route element={<BaseAuth />} path="/" />
                <Route element={<Login />} path="/login" />
                <Route element={<Register />} path="/Register" />
                <Route element={<RegisterModi />} path="/register-modi" />

                <Route element={<FrogetPassword />} path="/ForgotPassword" />
                <Route element={<Otp />} path="/otp" />
                <Route element={<QrCode />} path="/qrCodeLogin" />
                <Route element={<SignUp />} path="/singup" />

                <Route element={<Navigate to="/" replace />} path="/" />
                <Route
                  element={<Navigate to="/" replace />}
                  path="/sell/products"
                />
                <Route element={<Navigate to="/" replace />} path="/setting" />
                <Route element={<Navigate to="/" replace />} path="/price" />
                <Route element={<Navigate to="/" replace />} path="/buy" />
                <Route element={<Navigate to="/" replace />} path="/sell" />
                <Route
                  element={<Navigate to="/" replace />}
                  path="/sell/products/:id"
                />
                <Route
                  element={<Navigate to="/" replace />}
                  path="/sell/customer"
                />
                <Route
                  element={<Navigate to="/" replace />}
                  path="/sell/customer/create"
                />
                <Route
                  element={<Navigate to="/" replace />}
                  path="/sell/customer/:id"
                />
                <Route
                  element={<Navigate to="/" replace />}
                  path="/sell/products/create"
                />
                <Route
                  element={<Navigate to="/" replace />}
                  path="/sell/invoice"
                />
                <Route
                  element={<Navigate to="/" replace />}
                  path="/sell/invoice/create"
                />
              </Routes>
            </>
          ) : (
            <Layout>
              <Routes>
                <Route element={<Home />} path="/" />
                <Route element={<Navigate to="/" replace />} path="/login" />
                <Route element={<Navigate to="/" replace />} path="/Register" />
                <Route
                  element={<Navigate to="/" replace />}
                  path="/ForgotPassword"
                />
                <Route element={<Navigate to="/" replace />} path="/otp" />
                <Route
                  element={<Navigate to="/" replace />}
                  path="/qrCodeLogin"
                />

                <Route element={<Products />} path="/sell/products" />
                <Route element={<Settings />} path="/setting" />
                <Route element={<Price />} path="/price" />
                <Route element={<Sell />} path="/sell" />
                <Route element={<EditProduct />} path="/sell/products/:id" />
                <Route element={<Customer />} path="/sell/customer" />
                <Route
                  element={<CreateCustomer />}
                  path="/sell/customer/create"
                />
                <Route element={<EditCustomer />} path="/sell/customer/:id" />
                <Route
                  element={<CreateProduct />}
                  path="/sell/products/create"
                />
                <Route element={<Invoice />} path="/sell/invoice" />
                <Route
                  element={<CreateInvoice />}
                  path="/sell/invoice/create"
                />
                <Route element={<EditInvoice />} path="/sell/invoice/:id" />

                <Route element={<PriviewInvoice />} path="/sell/preview/:id" />

                {/* ------------------------------------ buy ------------------------------- */}
                <Route element={<EditProductBuy />} path="/buy/products/:id" />
                <Route element={<ProductsBuy />} path="/buy/products" />
                <Route
                  element={<CreateProductBuy />}
                  path="/buy/products/create"
                />
                <Route element={<Buy />} path="/buy" />
                <Route element={<CustomerBuy />} path="/buy/customer" />
                <Route
                  element={<CreateCustomerBuy />}
                  path="/buy/customer/create"
                />
                <Route element={<EditCustomerBuy />} path="/buy/customer/:id" />
                <Route element={<InvoiceBuy />} path="/buy/invoice" />
                <Route
                  element={<CreateInvoiceBuy />}
                  path="/buy/invoice/create"
                />
                <Route element={<EditInvoiceBuy />} path="/buy/invoice/:id" />
                <Route
                  element={<PriviewInvoiceBuy />}
                  path="/buy/preview/:id"
                />
              </Routes>
            </Layout>
          )}
        </HashRouter>
        <CssBaseline />
        {!online && (
          <Box
            className="flex fixed top-0 w-full text-white justify-center items-center py-3 text-sm font-bold"
            sx={{ background: (theme) => theme.palette.error.light }}
          >
            <CloudOffIcon sx={{ mx: 1 }} />
            دسترسی شما به اینترنت قطع شد
          </Box>
        )}
        <Modal
          open={newVersion}
          onClose={() => {
            setNewVersion(false);
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { md: "90%", xs: "90%" },
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 2,
              borderRadius: 2,
              overflow: "auto",
              maxHeight: "95%",
              maxWidth: "400px",
            }}
          >
            <div className="border-b border-solid pb-4">
              <h2 className="text-sm font-bold">
                ورژن جدیدی از برنامه در درسترس است{" "}
              </h2>
            </div>
            <div className="flex col-span-2 justify-between items-center mt-5">
              <Button
                onClick={handleUpdate}
                sx={{ width: "8rem" }}
                variant="contained"
                color="primary"
              >
                <> بروزرسانی</>
              </Button>{" "}
              <Button
                onClick={() => {
                  setNewVersion(false);
                }}
                sx={{ width: "8rem", background: "#ccc" }}
                variant="contained"
                color="inherit"
              >
                انصرف
              </Button>
            </div>
          </Box>
        </Modal>
        <ToastContainer
          position="top-right"
          hideProgressBar={false}
          closeOnClick={true}
          rtl={true}
          pauseOnFocusLoss={true}
          draggable={true}
          pauseOnHover={true}
        />
      </ThemeProvider>
      {popUp && !isLg && (
        <div
          style={{ zIndex: 999999 }}
          className="fixed shadow-2xl bottom-0 w-full flex left-0 right-0 px-2 py-2 items-center rounded-t-xl justify-between mainBg"
        >
          <div
            onClick={() => {
              dispatch(handlePopUpPwaAction(false));
              setopenModal(true);
            }}
            className="flex items-center gap-3 cursor-pointer"
          >
            <img
              src={"/assets/images/logos/ios/256.png"}
              className="w-[50px] h-[50px]"
              alt=""
            />
            <h2 className="text-base text-white">
              دانلود {process.env.REACT_APP_TITLE}
            </h2>
          </div>
          <CloseIcon
            onClick={() => dispatch(handlePopUpPwaAction(false))}
            style={{ color: "#fff" }}
          />
        </div>
      )}
      {openModal && (
        <Modal
          open={openModal}
          onClose={() => {
            setopenModal(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          classes={{ root: "storyModal" }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { md: "100%", xs: "90%" },
              bgcolor: "background.paper",
              borderRadius: 2,
              maxWidth: "400px",
              border: "none",
              outline: "none",
              p: 2,
              maxHeight: "90%",
              overflow: "auto",
              zIndex: 999999,
            }}
          >
            {os === "MacOS" ? (
              <div className="flex flex-col gap-2">
                <div className="flex justify-between items-center border-b mb-2 pb-2">
                  {" "}
                  <h2 className="text-base font-bold">
                    نحوه نصب برنامه روی iOS
                  </h2>
                  <IconButton
                    onClick={() => {
                      setopenModal(false);
                    }}
                  >
                    <CloseIcon />
                  </IconButton>{" "}
                </div>{" "}
                <span className="text-xs">
                  وب‌سایت را در مرورگر سافاری (Safari) باز کنید و 3 مرحله زیر را
                  طی نمایید.
                </span>
                <img
                  src="/assets/images/login/step1.jpg"
                  loading="lazy"
                  alt=""
                />
                <img
                  src="/assets/images/login/step2.jpg"
                  loading="lazy"
                  alt=""
                />
                <img
                  src="/assets/images/login/step3.jpg"
                  loading="lazy"
                  alt=""
                />
              </div>
            ) : (
              <>
                {" "}
                <div className="flex justify-between items-center border-b mb-2 pb-2">
                  {" "}
                  <h2 className="text-base font-bold ">
                    نحوه نصب برنامه روی android
                  </h2>{" "}
                  <IconButton
                    onClick={() => {
                      setopenModal(false);
                    }}
                  >
                    <CloseIcon />
                  </IconButton>{" "}
                </div>{" "}
                <a
                  onClickCapture={() => {
                    setopenModal(false);
                  }}
                  href={process.env.REACT_APP_ANDROID_LINK}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  {" "}
                  <img
                    src="/assets/images/login/android.png"
                    className="w-[150px]"
                    loading="lazy"
                    alt=""
                  />
                </a>
              </>
            )}
          </Box>
        </Modal>
      )}
    </div>
  );
}

export default App;
